import { useCallback, useState } from 'react';
import * as THREE from 'three';

export function useCameraState() {
  const [sceneCamera, setSceneCamera] = useState<THREE.Camera | null>(null);

  const handleSceneCameraDetected = useCallback((camera: THREE.Camera | null) => {
    setSceneCamera((prev) => {
      if (prev === camera) return prev;
      return camera;
    });
  }, []);

  const resetCameraState = useCallback(() => {
    setSceneCamera(null);
  }, []);

  return {
    sceneCamera,
    handleSceneCameraDetected,
    resetCameraState,
  };
}
